export default class ReceiptStatus {
    constructor(tagId, flowStatus, flowStatusReason, lastUpdated, lastUpdatedBy, lastStatus, lastStatusReason){
        this.tagId = tagId.toString() || "";
        this.flowStatus = flowStatus || "";
        this.flowStatusReason = flowStatusReason || "";
        this.lastUpdated = lastUpdated || "";
        this.lastUpdatedBy = lastUpdatedBy || "";
        this.lastStatus = lastStatus || "";
        this.lastStatusReason = lastStatusReason || "";
    }
}